module.exports = __webpack_public_path__ + "img/logo-login.3596ff66.svg";